import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { FC } from 'react';

const AboutSkeletonDesktop: FC = () => {
  return (
    <SkeletonGroup>
      <Box direction="horizontal" gap="18px" width="100%">
        <Box direction="vertical" flex="2">
          <SkeletonRectangle height="312px" />
        </Box>
        <Box direction="vertical" gap="18px" flex="1">
          <SkeletonRectangle height="156px" />
          <SkeletonRectangle height="138px" />
        </Box>
      </Box>
    </SkeletonGroup>
  );
};

export default AboutSkeletonDesktop;
